'use es6';

/**
 * Excludes infinite animations, whose finished promises never resolve while they run.
 */
export function getFiniteAnimations(element, options) {
  return element.getAnimations(options).filter(animation => {
    var _animation$effect;
    const timing = (_animation$effect = animation.effect) === null || _animation$effect === void 0 ? void 0 : _animation$effect.getTiming();
    return (timing === null || timing === void 0 ? void 0 : timing.duration) !== Infinity && (timing === null || timing === void 0 ? void 0 : timing.iterations) !== Infinity;
  });
}